
import { Component, Prop, Vue } from 'vue-property-decorator';
import { OrderItem, SalesQuote, SalesQuoteItem, SapProduct } from '@/api/model';
import OrderTotals from '@/components/orders/OrderTotals.vue';
import ContainerCalculationTotals from '@/components/container-calculation/ContainerCalculationTotals.vue';
import BaseCurrencyAmount from '@/components/BaseCurrencyAmount.vue';
import NewClaimOverviewProductsTotals from '@/components/claims/new-claim/NewClaimOverviewProductsTotals.vue';
import { ClaimTotals } from '@/types/ClaimTotals';

@Component({
  components: {
    NewClaimOverviewProductsTotals,
    OrderTotals,
    ContainerCalculationTotals,
    BaseCurrencyAmount,
  },
})
export default class OrderItemList extends Vue {
  @Prop({ type: Array, default: () => [] })
  items!: OrderItem[];

  @Prop({ type: String, default: 'default' })
  type!: 'default' | 'container-calculation' | 'claim';

  @Prop({ type: Boolean, default: false })
  sortByCart!: boolean;

  @Prop({ type: Boolean, default: true })
  striped!: boolean;

  @Prop({ type: Object, default: () => undefined })
  agreement!: SalesQuote;

  @Prop({ type: Object, default: () => undefined })
  claimTotals!: any;

  get defaultSort(): any[] {
    return this.sortByCart ? [] : ['ItemText', 'asc'];
  }

  get itemsData(): any[] {
    return this.items;
  }

  calculateBoxes(item: OrderItem): number {
    return this.$store.getters['container/calculateBoxes'](item);
  }

  get relatedProducts(): SapProduct[] {
    return this.$store.state.order.products.filter((product: SapProduct) =>
      this.items.some(
        (item: OrderItem) => item.ProductNr === product.ProductNr,
      ),
    );
  }

  getProductFromOrderItem(orderItem: OrderItem): SapProduct | undefined {
    let product;
    // eslint-disable-next-line no-unused-expressions
    this.agreement.items?.some((agrItem) => {
      const p = agrItem.sap_product;
      if (p?.ProductNr === orderItem.ProductNr) {
        product = p;
        return true;
      }
      return false;
    });
    return product;
  }

  agreementItem(orderItem: OrderItem): SalesQuoteItem {
    const product = this.getProductFromOrderItem(orderItem);
    return this.agreement?.items?.find(
      (item) => item.sap_product === product,
    ) as SalesQuoteItem;
  }

  calculateClaim(orderItem: any): ClaimTotals {
    if (orderItem.volume) {
      return {
        volume: orderItem.volume,
        billbackAmount: orderItem.billbackAmount,
      };
    }
    const product = this.getProductFromOrderItem(orderItem);
    return this.$store.getters['claim/getItemCalculation'](product);
  }
}
